import { render } from "./addOrganization.vue?vue&type=template&id=9534cd74"
import script from "./addOrganization.vue?vue&type=script&lang=js"
export * from "./addOrganization.vue?vue&type=script&lang=js"

import "./addOrganization.vue?vue&type=style&index=0&id=9534cd74&lang=less"
script.render = render

export default script